import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// 컴포넌트들 가져오기
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import InterviewApp from './pages/InterviewApp';
import AboutPage from './pages/AboutPage';
import GuidePage from './pages/GuidePage';
import GuideSuccessPage from './pages/GuideSuccessPage';

// 개별 가이드들
import SelfIntroGuide from './pages/guides/SelfIntroGuide';
import MotivationGuide from './pages/guides/MotivationGuide';
import StrengthsWeaknessesGuide from './pages/guides/StrengthsWeaknessesGuide';
import SpeakingSkillsGuide from './pages/guides/SpeakingSkillsGuide';
import DressAppearanceGuide from './pages/guides/DressAppearanceGuide';
import StarMethodGuide from './pages/guides/StarMethodGuide';
import UnexpectedQuestionsGuide from './pages/guides/UnexpectedQuestionsGuide';
import ConclusionFirstGuide from './pages/guides/ConclusionFirstGuide';
import InterviewDayGuide from './pages/guides/InterviewDayGuide';
import FinalWordsGuide from './pages/guides/FinalWordsGuide';
import MentalManagementGuide from './pages/guides/MentalManagementGuide';
import InterviewAllowanceGuide from './pages/guides/InterviewAllowanceGuide';

// 🆕 PWA 설치 안내 컴포넌트 추가 (이 줄만 추가!)
import PWAInstallGuide from './components/PWAInstallGuide';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  // 배경 클래스 - 전체 레이아웃 조정
  const bgClass = darkMode 
    ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white' 
    : 'bg-gradient-to-br from-blue-50 via-white to-purple-50 text-gray-800';

  return (
    <Router>
      {/* 🎯 전체 앱을 80% 크기로 조절 */}
      <div 
        className={`min-h-screen flex flex-col ${bgClass}`}
        style={{
          transform: 'scale(0.8)',
          transformOrigin: 'top left',
          width: '125%', // 80%로 줄였으니 125%로 보정
          minHeight: '125vh' // 세로도 보정
        }}
      >
        <Navigation darkMode={darkMode} setDarkMode={setDarkMode} />
        
        {/* 메인 콘텐츠 영역 - 전체적인 여백 조정 */}
        <main className="flex-1">
          <Routes>
            {/* 메인 페이지 - 특별한 레이아웃 (광고 공간 포함) */}
            <Route path="/" element={<InterviewApp darkMode={darkMode} />} />
            
            {/* 나머지 페이지들 - 표준 컨테이너 */}
            <Route path="/about" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <AboutPage darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <GuidePage darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <GuideSuccessPage darkMode={darkMode} />
              </div>
            } />
            
            {/* 개별 가이드 페이지들 - 표준 컨테이너 */}
            <Route path="/guide-success/self-intro" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <SelfIntroGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/motivation" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <MotivationGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/strengths-weaknesses" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <StrengthsWeaknessesGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/speaking-skills" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <SpeakingSkillsGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/dress-appearance" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <DressAppearanceGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/star-method" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <StarMethodGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/unexpected-questions" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <UnexpectedQuestionsGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/conclusion-first" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <ConclusionFirstGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/interview-day" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <InterviewDayGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/final-words" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <FinalWordsGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/mental-management" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <MentalManagementGuide darkMode={darkMode} />
              </div>
            } />
            
            <Route path="/guide-success/interview-allowance" element={
              <div className="max-w-4xl mx-auto px-4 py-8">
                <InterviewAllowanceGuide darkMode={darkMode} />
              </div>
            } />
          </Routes>
        </main>

        {/* 푸터 */}
        <Footer darkMode={darkMode} />
        
        {/* 🆕 PWA 설치 안내 버튼 (이 줄만 추가!) */}
        <PWAInstallGuide darkMode={darkMode} />
      </div>
    </Router>
  );
}

export default App;